import clsx from 'clsx'
import { Link, type LinkProps } from 'react-router-dom'
import { type ReactNode } from 'react'

type LinkButtonProps = LinkProps & {
  children: ReactNode
  fullWidth?: boolean
  variant?: 'primary' | 'outline'
  size?: 'small' | 'medium' | 'large'
}

export const LinkButton = ({
  fullWidth = false,
  variant = 'primary',
  size = 'medium',
  children,
  className,
  ...rest
}: LinkButtonProps) => {
  return (
    <Link
      className={clsx(
        'px-4 rounded-lg border-1 border-transparent transition-colors text-sm font-medium lg:text-base items-center flex justify-center gap-2',
        {
          'bg-primary-light text-white hover:bg-secondary-dark disabled:bg-[#C9D8E1] disabled:text-[#ADCADA]':
            variant === 'primary',
          'border-primary-light text-primary-light hover:bg-[#C9D8E1] disabled:bg-transparent disabled:border-[#C9D8E1] disabled:text-[#ADCADA]':
            variant === 'outline',
          'py-[6px] h-8': size === 'small',
          'py-[11px] h-10': size === 'medium',
          'py-[14px] h-12': size === 'large',
          'w-full': fullWidth,
        },
        className
      )}
      {...rest}
    >
      {children}
    </Link>
  )
}
